import {Component} from '@angular/core';
import {PageContainerComponent} from "../../../_components/page-container/page-container.component";
import {HeaderContainerComponent} from "../../../_components/header-container/header-container.component";
import {FormContainerComponent} from "../../../_components/form-container/form-container.component";
import {PermissionService} from "../../../_auth/permission.service";
import {GlobalAlertService} from "../../../_services/global-alert.service";
import {BusinessCaseHttpService} from "../_services/business-case-http.service";
import {ComponentBase} from "../../../_abstracts/component-base";
import {BusinessCaseDto} from "../_models/business-case-dto";
import {AlertLevel} from "../../../enums/alert-level";
import {BusinessCaseNew} from "../_models/business-case-new";
import {FormsModule} from "@angular/forms";
import {NgSelectModule} from "@ng-select/ng-select";
import {BusinessCaseType, BusinessCaseTypeLabels} from "../../location/_models/_enums/business-case-type";
import {
  BusinessCaseCalculationType,
  BusinessCaseCalculationTypeLabels
} from "../_models/_enums/business-case-calculation-type";
import {PageScrollableComponent} from "../../../_components/page-scrollable/page-scrollable.component";
import {DecimalPipe, NgIf} from "@angular/common";
import {finalize} from "rxjs";
import {LoadingComponent} from "../../x-components/loading/loading.component";

@Component({
  selector: 'app-business-cases',
  imports: [
    PageContainerComponent,
    HeaderContainerComponent,
    FormContainerComponent,
    FormsModule,
    NgSelectModule,
    PageScrollableComponent,
    NgIf,
    DecimalPipe,
    LoadingComponent
  ],
  templateUrl: './business-cases.component.html',
  styleUrl: './business-cases.component.scss'
})
export class BusinessCasesComponent extends ComponentBase {
  protected bc_full: BusinessCaseDto[] | undefined | null = undefined;
  protected bc: BusinessCaseDto[] | undefined | null = undefined;
  protected search: string = "";
  protected types = Object.keys(BusinessCaseType).slice(0, Object.entries(BusinessCaseType).length / 2);
  protected calculationTypes = Object.keys(BusinessCaseCalculationType).slice(0, Object.entries(BusinessCaseCalculationType).length / 2);
  protected new: BusinessCaseNew = new BusinessCaseNew();
  protected readonly parseInt = parseInt;
  protected readonly BusinessCaseTypeLabels = BusinessCaseTypeLabels;
  protected readonly BusinessCaseCalculationTypeLabels = BusinessCaseCalculationTypeLabels;

  constructor(protected PermissionService: PermissionService,
              private gas: GlobalAlertService,
              private bcs: BusinessCaseHttpService) {
    super();
  }

  add() {
    if (this.new.name.isNullOrWhitespace()) {
      this.gas.createAndShow("Fehler", "Bitte geben Sie einen Namen ein.", AlertLevel.error);
      return;
    }

    if (!this.bc_full) this.bc_full = [];

    this.bcs.add(this.new).withLoadingIndicator().subscribe({
      next: data => {
        this.gas.createAndShow("Erfolg", "Geschäftsvorfall erfolgreich hinzugefügt.", AlertLevel.success);
        this.bc_full?.splice(0, 0, data);
        this.new.name = "";
      },
      error: err => {
        console.error(err);
        this.gas.createAndShow("Fehler", "Fehler beim Hinzufügen des Geschäftsvorfalls.", AlertLevel.error);
      }
    })
  }

  delete(bc: BusinessCaseDto) {
    if (!confirm(`Sind Sie sicher, dass Sie  Geschäftsvorfall "${bc.name}" löschen möchten?`)) return;

    this.bcs.delete(bc.id).withLoadingIndicator().subscribe({
      next: () => {
        this.gas.createAndShow("Erfolg", "Geschäftsvorfall erfolgreich gelöscht.", AlertLevel.success);
        this.bc_full?.splice(this.bc_full?.findIndex(x => x.id === bc.id), 1);
        this.filter(this.search);
      },
      error: err => {
        console.error(err);
        this.gas.createAndShow("Fehler", "Fehler beim Löschen des Geschäftsvorfalls.", AlertLevel.error);
      }
    })
  }

  protected override load() {
    this.bcs.list()
      .pipe(finalize(() => {
        this.filter(this.search);
      }))
      .withLoadingIndicator().subscribe({
      next: (data) => {
        this.bc_full = data;
      },
      error: (err) => {
        console.error(err);
        this.bc_full = null;
        this.gas.createAndShow("Fehler", "Fehler beim Laden der Geschäftsvorfälle", AlertLevel.error);
      }
    })
  }

  protected filter(search: string) {
    this.search = search;

    if (this.bc_full === undefined || this.bc_full === null) {
      this.bc = this.bc_full;
      return;
    }

    if (this.search.isNullOrWhitespace()) {
      this.bc = Object.assign([], this.bc_full);
    } else {
      this.bc = Object.assign([], this.bc_full.filter(x => x.name.toLowerCase().includes(this.search.toLowerCase())));
    }
  }
}
